import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@comparethemarketau/manor-typography';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { applicantFirstName } from '../../../../core/state_selectors';
import { withAvailableQuotes } from '../../products/common/with_available_quotes';

const _SummaryTitle = (props) => {
    const { firstName, className, availableQuotesSize } = props;
    return (
        <Typography className={classNames('test-policySummary-title', className)}>
            {
                `${availableQuotesSize > 0 ? 'Thanks' : 'Sorry'} ${firstName}.`
            }
        </Typography>
    );
};

_SummaryTitle.propTypes = {
    firstName: PropTypes.string,
    className: PropTypes.string,
    availableQuotesSize: PropTypes.number
};

const mapStateToProps = (state) => ({ firstName: applicantFirstName({ state }) });

const SummaryTitle = withAvailableQuotes(connect(mapStateToProps)(_SummaryTitle));

export { SummaryTitle, _SummaryTitle };
